import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import Popper from "@mui/material/Popper";
import Checkbox from '@mui/material/Checkbox';
import TextField from "@mui/material/TextField";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import './InputAutoComplete.css'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const InputAutoComplete = ({
  label = "",
  placeholder = "",
  options = [],
  value,
  onChange,
  getOptionLabel = (option) => option.label || "",
  filterFunction,
  name,
  multiple = false,
}) => {
  const defaultFilter = (options, { inputValue }) => {
    const cleanText = (str) => {
      if (!str) return "";
      return str
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[.,\-\s]/g, "")
        .trim();
    };

    const cleanInputValue = cleanText(inputValue);

    return options.filter(
      (option) =>
        option &&
        getOptionLabel(option) &&
        cleanText(getOptionLabel(option)).includes(cleanInputValue)
    );
  };

  return (
    <div className="autoCompleteInputWrapperCompany">
      {label && (
        <label className="selectLabel" htmlFor={name}>
          {label}
        </label>
      )}
      <div className="auto-complete-wrapper-company">
        <Autocomplete
          multiple={multiple}
          className="autoComplete"
          disableCloseOnSelect
          options={options}
          getOptionLabel={(option) => getOptionLabel(option)}
          filterOptions={filterFunction || defaultFilter}
          PopperComponent={(props) => (
            <Popper
              {...props}
              disablePortal
              style={{
                ...props.style,
                width: props.anchorEl?.clientWidth,
                zIndex: 9999,
              }}
              placement="bottom-start"
            />
          )}
          value={multiple ? (Array.isArray(value) ? value : []) : value || null}
          onChange={onChange}
          renderInput={(params) => (
            <TextField {...params} placeholder={placeholder} />
          )}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          renderOption={(props, option, { selected }) => {
            const { key, ...optionProps } = props;
            return (
              <li className="optionCustom" key={key} {...optionProps}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  checked={selected}
                />
                {getOptionLabel(option)}
              </li>
            );
          }}
          noOptionsText="Nada encontrado"
        />
      </div>
    </div>
  );
};
